import { render, staticRenderFns } from "./bookings2.vue?vue&type=template&id=7c731bd6"
import script from "./bookings2.vue?vue&type=script&lang=js"
export * from "./bookings2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports